/**
 * Created by Alican Köker on 2019-05-22.
 */
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { IResizeData, StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import { EdisonGameConfig } from "../EdisonGameConfig";
import { ScalableLayer } from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { ServerEvent } from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { EdisonParsedGameData } from "../server/data/EdisonParsedGameData";
import { EdisonParsedInitData } from "../server/data/EdisonParsedInitData";
import { EdisonHelper } from "../../utils/EdisonHelper";
import { SpinEvent } from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import { ReelEvent } from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import { Orientation } from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import { TimelineLite } from "gsap";
import { EdisonGameMode } from "../gameMode/EdisonGameMode";
import { EdisonIndividualWPView } from "../winpresentation/individual/EdisonIndividualWPView";
import { ScatterOverlayObject } from "./ScatterOverlayObject";

export class EdisonScatterOverlay extends BaseView {

    private _layer:ScalableLayer;
    private _gameData:EdisonParsedGameData | EdisonParsedInitData;
    private _scatterOverlayContainer:PIXI.Sprite;
    private _scatters:ScatterOverlayObject[];
    private _isRestore:boolean = false;
    private _orientation:Orientation = Orientation.LANDSCAPE;
    private _modeChangeAnimTimeline:TimelineLite;
    private _gameMode:EdisonGameMode;
    private _nextMode:EdisonGameMode;
    private _yPadding:number = 0;
    private _showLast:boolean = false;

    constructor() {
        super();

        this._layer = StageManager.getLayer(EdisonGameConfig.instance.LAYERS.FOREGROUND.name);
        this._scatters = [];

        this._scatterOverlayContainer = new PIXI.Sprite();
        this._layer.addChild(this._scatterOverlayContainer);

        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ReelEvent.REEL_STOP_PRESENTATIONS_COMPLETE, (event:GameEvent) => this.playOverlayAnimations(event.params[0]));
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, () => this.removeScatters());
        EventHandler.addEventListener(this, SpinReelEvent.REEL_STOP_SPIN_BOUNCE_STARTED, (event:GameEvent) => {
            if(event.params[0].reelId === 0)
                this._scatterOverlayContainer.visible = true;
        });
        EventHandler.addEventListener(this, EdisonIndividualWPView.SET_MODE, (event:GameEvent) => this._nextMode = event.params[0]);

    }


    protected onGameDataParsed(data:EdisonParsedGameData | EdisonParsedInitData):void {
        this._gameData = data;
        if(data instanceof EdisonParsedGameData) {
            this._isRestore = false;
        } else {
            this._isRestore = data.isRestoreState;
            this._gameMode = data.nextMode;
        }

    }

    protected initAnimations():void {
        for(let i:number = 0; i < EdisonGameConfig.instance.REELS_NUM; i++) {
            for(let j:number = 0; j < EdisonGameConfig.instance.SYMBOLS_NUM_IN_REEL[2]; j++) {
                let pos:number[] = EdisonHelper.getSymbolPosition(i, j);
                let scatter:ScatterOverlayObject = new ScatterOverlayObject();
                scatter.container.position.set(pos[0] - 16, pos[1] - 3 + this._yPadding);

                this._scatters.push(scatter);
                this._scatterOverlayContainer.addChild(scatter.container);
            }
        }
    }

    private playOverlayAnimations(reelId:number):void {
        let numboerOfLandedScatters:number = this.getNumberOfLandedScatters(reelId);
        if(this._gameData.scatterPositions![reelId] > -1) {
            if(numboerOfLandedScatters === 0 || (reelId === 4 && numboerOfLandedScatters === 1 && !this._showLast)) {
                this._scatters[reelId * 3 + this._gameData.scatterPositions![reelId]].playAnimation("Initial");
            } else if(numboerOfLandedScatters >= 1) {
                for(let i:number = 0; i < reelId + 1; i++) {
                    if(this._gameData.scatterPositions![i] > -1)
                        this._scatters[i * 3 + this._gameData.scatterPositions![i]].playAnimation("Anticipation", true);
                }
            }
        }
        if(reelId === EdisonGameConfig.instance.REELS_NUM - 1){
            let tl:TimelineLite = new TimelineLite();
            tl.add(() => {
                this.stopOverlayAnimations();
            }, .4);

            if((<EdisonParsedGameData>this._gameData)!.singleWin > 0 && !(<EdisonParsedGameData>this._gameData)!.freespinTriggeredThisSpin)
                this.tintOverlays();
        }
    }

    public stopOverlayAnimations():void{
        for(let i:number = 0; i < this._scatters.length; i++){
            this._scatters[i].stopAnimation();
        }
    }

    public tintOverlays():void{
        for(let i:number = 0; i < this._scatters.length; i++){
            this._scatters[i].dim();
        }
    }

    public playFreespinWonAnimation():TimelineLite {
        let tl:TimelineLite = new TimelineLite();
        for(let i:number = 0; i < EdisonGameConfig.instance.REELS_NUM; i++) {
            if(this._gameData.scatterPositions![i] > -1) {
                tl.add(() => {
                    this._scatters[i * 3 + this._gameData.scatterPositions![i]].playAnimation("ThreeHit");
                });
            }
        }
        return tl;
    }

    private getNumberOfLandedScatters(reelId:number):number {
        let count:number = 0;
        for(let i:number = 0; i < reelId; i++) {
            if(this._gameData!.scatterPositions![i] > -1)
                count++;
        }
        return count;
    }


    public removeScatters():void {
        this._scatterOverlayContainer.visible = false;
        this._scatters.forEach((scatter) => {
            scatter.stopAnimation();
            scatter.reset();
            scatter.undim();
        });
    }

    public setNoWin():void {
        this._scatterOverlayContainer.children.forEach((child) => {
            (<PIXI.Sprite>child).tint = 0x888888;
        });
    }

    protected onResize(resizeData:IResizeData):void {
        if(this._orientation === resizeData.orientation)
            return;

        if(this._modeChangeAnimTimeline && this._modeChangeAnimTimeline.isActive()) {
            this._modeChangeAnimTimeline.pause();
            this._modeChangeAnimTimeline.kill();
            this._gameMode = this._nextMode;
        }

        this._orientation = resizeData.orientation;

        this._yPadding = resizeData.orientation === Orientation.PORTRAIT ? -106 : 0;

        for(let i:number = 0; i < EdisonGameConfig.instance.REELS_NUM; i++) {
            for(let j:number = 0; j < EdisonGameConfig.instance.SYMBOLS_NUM_IN_REEL[2]; j++) {
                let pos:number[] = EdisonHelper.getSymbolPosition(i, j);
                let scatter:ScatterOverlayObject = this._scatters[i * 3 + j];
                scatter.container.position.set(pos[0] - 16, pos[1] - 3 + this._yPadding);

            }
        }

    }
}